﻿
import { PurchasingAgreementStepsComponent } from "./PurchasingAgreementStepsComponent.js";
import { PurchasingAgreementService } from "./PurchasingAgreementService.js";
import { PurchasingAgreementForm } from "./PurchasingAgreementForm.js";

const PurchaseAgreement = (function () {
    var init = function () {
        var purchasingAgreementFormSelector = "#PurchasingAgreementForm";
        var isInternalSite = Number.parseInt($('#IsInternal').val()) === 1;
        var agreementType = $('#AgreementType').val();
        var priceAreaId = Number.parseInt($('#PriceArea').val());
        var $btnSubmit = $('.btnSaveAgreement');
        if ($(purchasingAgreementFormSelector).length === 0) {
            return;
        }

        var purchasingAgreementService = new PurchasingAgreementService();
        var stepsComponent = new PurchasingAgreementStepsComponent(agreementType, isInternalSite);
        var purchasingAgreementForm = new PurchasingAgreementForm(
            purchasingAgreementFormSelector,
            purchasingAgreementService,
            stepsComponent,
            isInternalSite,
            agreementType,
            priceAreaId);

        purchasingAgreementForm.on("save", function (event) {
            var resp = event.response;

            if (event.isPriceWatch) {
                stepsComponent.next();
                return; // Price watch created, no further steps
            }

            if ($('.errorSaveAgreement'))
                $('.errorSaveAgreement').remove();

            var errorInstructions = '<p>Ett fel uppstod när avtalet ' + resp.AgreementNumber + ' skulle skickas. Vänligen forsök igen senare. </p>';
            var $error = $('<div class="errorSaveAgreement errors-list">').html(errorInstructions);

            if (resp.Message && (resp.Message.indexOf("Error") >= 0 || resp.Message.indexOf("Fel") >= 0)) {
                $btnSubmit.closest('.lm__block').prepend($error);
                $('.div-signing-loader').addClass('hidden');
                $btnSubmit.prop("disabled", false).removeClass('disabled');
                return;

            }
            if (resp.SigningUrl && (resp.SigningUrl == null || resp.SigningUrl.indexOf("Error") >= 0 || resp.SigningUrl.indexOf("Fel") >= 0 || resp.SigningUrl.indexOf("http") < 0)) {
                $btnSubmit.closest('.lm__block').prepend($error);
                $('.div-signing-loader').addClass('hidden');
                $btnSubmit.prop("disabled", false).removeClass('disabled');
                return;

            }
            $('input[name="AgreementNumber"]').val(resp.AgreementNumber);
            $('input[name="SigningUrl"]').val(resp.SigningUrl);
            if (isInternalSite) {
                if (!(resp.Recipients && resp.Recipients.Signers && resp.Recipients.Signers.length > 0)) {
                    //throw "No recipients";
                    $btnSubmit.closest('.lm__block').prepend($error);
                    $('.div-signing-loader').addClass('hidden');
                    $btnSubmit.prop("disabled", false).removeClass('disabled');
                    return;
                }

                var receiver = resp.Recipients.Signers[0];
                var data = {};
                data.AgreementNumber = resp.AgreementNumber;
                data.SigningUrl = resp.SigningUrl;
                data.ReceiverName = receiver.Name;
                data.ReceiverEmail = receiver.Email;
                data.ReceiverPersonalNumber = receiver.PersonalNumber;
                data.ReceiverMobilePhoneNumber = receiver.MobilePhoneNumber;
                data.Message = resp.Message;
                data.HarvestYear = resp.HarvestYear;
                data.ValidityPeriod = resp.ValidityPeriod;

                purchasingAgreementService.sendForDigitalSigning(data)
                    .done(function (resp) {
                        if (resp !== "OK") {
                            $btnSubmit.closest('.lm__block').prepend($error);
                            return;
                        }
                        stepsComponent.next();
                    })
                    .always(function () {
                        setTimeout(function () {
                            $('.div-signing-loader').addClass('hidden');
                            $btnSubmit.prop("disabled", false).removeClass('disabled');
                        }, 100);
                    });
            } else {
                setTimeout(function () {
                    window.open(resp.SigningUrl, "_blank");
                    $('#DigitalSigningLink').attr("href", resp.SigningUrl);

                    setTimeout(function () {
                        stepsComponent.next();
                    }, 500);
                }, 500);

            }
        });
    };

    return {
        init: init
    };
})();

$(function () {
    PurchaseAgreement.init();
});